/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { UserApiService } from './services/user-api.service';
import { BackofficeApiService } from './services/backoffice-api.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    UserApiService,
    BackofficeApiService,
    ApiConfiguration
  ],
})
export class BackofficeApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<BackofficeApiModule> {
    return {
      ngModule: BackofficeApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: BackofficeApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('BackofficeApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
